export enum SnapshotTypeEnum {
  CM = 'CMVOLSURFACE',
  EE = 'VOLSURFACE',
}
